{
  "name": "nose-frontend",
  "version": "0.0.0",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "start:local": "ng serve --configuration local",
    "build": "ng build && npm run sentry:sourcemaps",
    "watch": "ng build --watch --configuration development",
    "test": "ng test",
    "lint": "ng lint",
    "format": "ng lint --fix",
    "sentry:sourcemaps": "sentry-cli sourcemaps inject --org sentry --project nose-frontend ./dist && sentry-cli --url https://sentry.monitor.ky2help.com/ sourcemaps upload --org sentry --project nose-frontend ./dist"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^22.2.2",
    "@angular/common": "^22.2.2",
    "@angular/compiler": "^22.2.2",
    "@angular/core": "^22.2.2",
    "@angular/forms": "^22.2.2",
    "@angular/platform-browser": "^22.2.2",
    "@angular/router": "^22.2.2",
    "@friendlycaptcha/sdk": "^1.0.3",
    "@jsverse/transloco": "^8.4.0",
    "@lucide/angular": "^1.33.0",
    "@ngrx/signals": "22.0.0-rc.0",
    "@openng/icons": "^1.0.0",
    "@openng/optimus-ui": "^2.0.0",
    "@openng/optimus-ui-locale": "^2.0.0",
    "@openng/optimus-ui-themes": "^2.0.0",
    "@sentry/angular": "^10.70.0",
    "@sentry/cli": "^3.6.2",
    "angular-oauth2-oidc": "^22.0.2",
    "chart.js": "^4.5.1",
    "dayjs": "^1.11.23",
    "primeflex": "^4.0.0",
    "punycode": "^2.3.1",
    "rxjs": "~7.8.2",
    "tslib": "^2.8.1"
  },
  "devDependencies": {
    "@angular/build": "^22.2.2",
    "@angular/cli": "^22.2.2",
    "@angular/compiler-cli": "^22.2.2",
    "@eslint/js": "^10.0.1",
    "@types/punycode": "^2.1.4",
    "angular-eslint": "22.1.0",
    "eslint": "^10.8.1",
    "eslint-config-prettier": "^10.1.8",
    "eslint-plugin-prettier": "^5.5.6",
    "jsdom": "^30.0.1",
    "prettier": "^3.9.6",
    "typescript": "~6.0.3",
    "typescript-eslint": "8.67.0",
    "vitest": "^4.0.8"
  },
  "allowScripts": {
    "fsevents@2.3.3": true,
    "@parcel/watcher": true,
    "@sentry/cli": true,
    "esbuild": true,
    "lmdb": true,
    "msgpackr-extract": true
  }
}
